// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.light-theme {
  --primary-bgColor: #fefefe;
  --secondary-bgColor: #f4f7fe;
  --primary-themeColor: #8d773b;
  --font-color: #666;
  --secondary-fontColor: #84838f;
  --black-color: #000000;
  --dark-grayish-blue: #586172;
  --oasis: #FFEBBE;
  --golden-yellow: #E49E00;
  --water-leaf: #BCFAEA;
  --caribbean-green: #02BF90;
  --blue-magenta: #C3B8F6;
  --neon-blue: #5937F1;
  --whisper-rose: #F6D9D9;
  --carnelian: #B11313;
}
`, "",{"version":3,"sources":["webpack://./src/colors.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;AACtB","sourcesContent":[".light-theme {\n  --primary-bgColor: #fefefe;\n  --secondary-bgColor: #f4f7fe;\n  --primary-themeColor: #8d773b;\n  --font-color: #666;\n  --secondary-fontColor: #84838f;\n  --black-color: #000000;\n  --dark-grayish-blue: #586172;\n  --oasis: #FFEBBE;\n  --golden-yellow: #E49E00;\n  --water-leaf: #BCFAEA;\n  --caribbean-green: #02BF90;\n  --blue-magenta: #C3B8F6;\n  --neon-blue: #5937F1;\n  --whisper-rose: #F6D9D9;\n  --carnelian: #B11313;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
